import type { MessageSuccessResponse } from '@/types/auth'
import type { FeedbackPayload, MessagePayload } from '@/types/feedback'
import axios from 'axios'

const feedbackApiCall = async (
  abortController?: AbortController,
  params?: FeedbackPayload,
): Promise<MessageSuccessResponse> => {
  const { data } = await axios.post(
    '/feedback',
    { ...params },
    { signal: abortController?.signal },
  )
  return data.data
}

const feedbackMessageApiCall = async (
  abortController?: AbortController,
  params?: MessagePayload,
): Promise<MessageSuccessResponse> => {
  const { data } = await axios.post(
    '/message',
    { ...params },
    { signal: abortController?.signal },
  )
  return data.data
}

export { feedbackApiCall, feedbackMessageApiCall }
